var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.isLastStep)?_c('a',{staticClass:"onboarding-page__back-button",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('Icon',{attrs:{"icon":"arrow-left"}}),_vm._v(" "+_vm._s(_vm.$t('common.back'))+" ")],1):_c('span',{staticClass:"onboarding-page__back-button"})
}
var staticRenderFns = []

export { render, staticRenderFns }